import React from 'react';
import { IconProps } from '.';

const SvgBoxBestFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M11.891 5.5h.285c.47 0 1.138.076 1.653.483.563.444.816 1.177.64 2.202l-.008.043-.748 2.072h3.049c.945 0 1.738.746 1.738 1.7v.039l-1 6.461h-12v-8.333h3.627L11.891 5.5Zm-2.058 5.437 2.62-4.424c.298.028.568.106.756.254.193.153.4.462.281 1.206L12.287 11.3h4.475c.41 0 .72.309.737.667l-.856 5.533h-6.81v-6.563Zm-1 6.563v-6.333H6.5V17.5h2.333Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxBestFill;
